'use strict';

var _ = require('lodash');
var HostViewChartDataService = function HostViewChartDataService(fareChartTransformationService, FaresOptimizerConstants) {
  var transformedChartData = {
    fareLadderData: undefined,
    currentFareLadderData: undefined,
    recommendedFareLadderData: undefined,
    settings: undefined
  };
  function recommendationsAvailable(recommendationEntry) {
    return !_.find(recommendationEntry.groupedRows, function (recommendation) {
      return _.isNil(recommendation.recommendedFareTotal);
    });
  }
  function copyCurrentFaresToEffectiveAndRecommendedFares(recommendationEntry) {
    _.map(recommendationEntry.groupedRows, function (recommendation) {
      if (recommendation.actionCode === 'X') {
        if (_.isNil(recommendation.recommendedFareBase)) {
          recommendation.recommendedFareBase = recommendation.currentFareBase;
        }
        if (_.isNil(recommendation.recommendedFareTotal)) {
          recommendation.recommendedFareTotal = recommendation.currentFareTotal;
        }
        if (_.isNil(recommendation.effectiveBaseFare)) {
          recommendation.effectiveBaseFare = recommendation.currentFareBase;
        }
        if (_.isNil(recommendation.effectiveTotalFare)) {
          recommendation.effectiveTotalFare = recommendation.currentFareTotal;
        }
      }
    });
  }
  function getChartDataForHostView(recommendationEntry, settings) {
    initialize();
    prepareChartDataBasedOnRecommendationStatus(recommendationEntry, settings);
    transformedChartData.settings = settings;
    return transformedChartData;
  }
  function isShowRecommendedFares(recommendationEntry) {
    return recommendationEntry.status === FaresOptimizerConstants.NEW || recommendationEntry.status === FaresOptimizerConstants.PENDING || recommendationEntry.status === FaresOptimizerConstants.APPROVED || recommendationEntry.status === FaresOptimizerConstants.FILED || recommendationEntry.status === FaresOptimizerConstants.VALIDATED;
  }
  function isDiscardedRecommendation(recommendationEntry) {
    return recommendationEntry.status === FaresOptimizerConstants.UNDONE || recommendationEntry.status === FaresOptimizerConstants.REJECTED;
  }
  function initialize() {
    transformedChartData = {
      fareLadderData: undefined,
      currentFareLadderData: undefined,
      recommendedFareLadderData: undefined,
      settings: undefined
    };
  }
  function prepareChartDataBasedOnRecommendationStatus(recommendationEntry, settings) {
    if (isShowRecommendedFares(recommendationEntry)) {
      copyCurrentFaresToEffectiveAndRecommendedFares(recommendationEntry);
      if (recommendationsAvailable(recommendationEntry)) {
        settings.type = 'recommendation';
        settings.showEffectiveFares = true;
        transformedChartData.fareLadderData = fareChartTransformationService.transformHostFareLadder(recommendationEntry, settings);
        settings.type = 'current';
        transformedChartData.currentFareLadderData = fareChartTransformationService.transformCurrentHostFareLadder(recommendationEntry, settings);
        return;
      }
    }
    if (recommendationEntry.status === FaresOptimizerConstants.NO_RECOM) {
      settings.type = 'current';
      transformedChartData.fareLadderData = fareChartTransformationService.transformCurrentHostFareLadder(recommendationEntry, settings);
      return;
    }
    if (isDiscardedRecommendation(recommendationEntry)) {
      if (recommendationsAvailable(recommendationEntry)) {
        settings.type = 'current';
        transformedChartData.fareLadderData = fareChartTransformationService.transformCurrentHostFareLadder(recommendationEntry, settings);
        settings.type = 'recommendation';
        settings.showEffectiveFares = true;
        transformedChartData.recommendedFareLadderData = fareChartTransformationService.transformHostFareLadder(recommendationEntry, settings);
      }
    }
  }
  return {
    getChartDataForHostView: getChartDataForHostView
  };
};
HostViewChartDataService.$inject = ['FareChartTransformationService', 'FaresOptimizerConstants'];
module.exports = HostViewChartDataService;